module.exports = __webpack_public_path__ + "img/c.1f63060c.jpg";